// css文件中不要使用import
import 'babel-polyfill';
import '../css/reset.css';
import '../css/whatever.css';

import React, {Component} from 'react';
import ReactDOM, {render} from 'react-dom';
import Title from 'c-title'; 
import url from 'c-url';
import lang from './lang/index';
lang.init();

// 直播：upLive；声播upvoice
let feature = url.query('feature') ? url.query('feature') : 0;
let businessType = feature == 6666 ? 'upvoice': 'upLive';

class App extends Component {


    render() {
        return (
            <div>
                <div className='banner' data-type={businessType}></div>
                <div className='content'>
                    <div className='info'>
                        <div className='title'><p></p>{ lang.template('VIP是什么') }</div>
                        <div className='vip-rule what' dangerouslySetInnerHTML={{__html: lang.template('VIP形容内容')}}></div>
                    </div>
                    <div className='info'>
                        <div className='title'><p></p>{ lang.template('VIP获得方式') }</div>
                        <div className='vip-rule' dangerouslySetInnerHTML={{__html: lang.template('VIP获得方式内容')}}></div>
                    </div>
                    <div className='info info2'>
                        <div className='info3'>
                            <div className='title'><p></p>{ lang.template('VIP规则') }</div>
                            <div className='vip-rule' dangerouslySetInnerHTML={{__html: lang.template('VIP规则内容')}}></div>
                        
                        </div>
                        <div className='privilege'>
                            <ul>
                                <li>
                                    <div className='item'>
                                        <div className='grade vip-d'>{ lang.template('VIP等级') }</div>
                                        <div className='grade'>{ lang.template('充值要求(U钻)') }</div>
                                        <div className='grade'>{ lang.template('保级要求(U钻)') }</div>
                                    </div>
                                </li>
                                <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 1</div>
                                        <div className='grade'>10000</div>
                                        <div className='grade'>6000</div>
                                    </div>
                                </li>
                                <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 2</div>
                                        <div className='grade'>50000</div>
                                        <div className='grade'>30000</div>
                                    </div>
                                </li>
                                <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 3</div>
                                        <div className='grade'>100000</div>
                                        <div className='grade'>60000</div>
                                    </div>
                                </li>
                                <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 4</div>
                                        <div className='grade'>200000</div>
                                        <div className='grade'>120000</div>
                                    </div>
                                </li>
                                 <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 5</div>
                                        <div className='grade'>500000</div>
                                        <div className='grade'>300000</div>
                                    </div>
                                </li>
                                 <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 6</div>
                                        <div className='grade'>1000000</div>
                                        <div className='grade'>600000</div>
                                    </div>
                                </li>
                                <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 7</div>
                                        <div className='grade'>2000000</div>
                                        <div className='grade'>1200000</div>
                                    </div>
                                </li>
                                <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 8</div>
                                        <div className='grade'>5000000</div>
                                        <div className='grade'>3000000</div>
                                    </div>
                                </li>
                                <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 9</div>
                                        <div className='grade'>10000000</div>
                                        <div className='grade'>6000000</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='info info2'>
                        <div className='info3'>
                            <div className='title'><p></p>{ lang.template('VIP特权') }</div>
                            <div className='vip-rule' dangerouslySetInnerHTML={{__html: lang.template('VIP特权内容')}}></div>
                        </div>    
                        <div className='privilege'>
                            <ul>
                                <li>
                                    <div className='item'>
                                        <div className='grade vip-d'>{ lang.template('VIP等级') }</div>
                                        <div className='grade'>{ lang.template('禁言次数') }</div>
                                        <div className='grade'>{ lang.template('踢人次数') }</div>
                                    </div>
                                </li>
                                <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 1</div>
                                        <div className='grade'>3</div>
                                        <div className='grade'>0</div>
                                    </div>
                                </li>
                                <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 2</div>
                                        <div className='grade'>5</div>
                                        <div className='grade'>2</div>
                                    </div>
                                </li>
                                <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 3</div>
                                        <div className='grade'>5</div>
                                        <div className='grade'>3</div>
                                    </div>
                                </li>
                                <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 4</div>
                                        <div className='grade'>6</div>
                                        <div className='grade'>5</div>
                                    </div>
                                </li>
                                 <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 5</div>
                                        <div className='grade'>10</div>
                                        <div className='grade'>8</div>
                                    </div>
                                </li>
                                 <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 6</div>
                                        <div className='grade'>10</div>
                                        <div className='grade'>10</div>
                                    </div>
                                </li>
                                <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 7</div>
                                        <div className='grade'>15</div>
                                        <div className='grade'>10</div>
                                    </div>
                                </li>
                                <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 8</div>
                                        <div className='grade'>15</div>
                                        <div className='grade'>15</div>
                                    </div>
                                </li>
                                <li>
                                   
                                    <div className='item'>
                                        <div className='grade grade-cn'>VIP 9</div>
                                        <div className='grade'>25</div>
                                        <div className='grade'>25</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className='tishi'>
                            <h2>{lang.template('温馨提示')}</h2>
                            <p dangerouslySetInnerHTML={{__html: lang.template('提示内容')}}></p>
                        </div>
                    </div>
                    
                </div>
            </div>
        );
    }
}


render( <App /> , $('#wrap')[0]);
Title.set(lang.template('页面标题'));



// WEBPACK FOOTER //
// ./js/app.js